import { render, staticRenderFns } from "./NChips.vue?vue&type=template&id=625786bf"
import script from "./NChips.vue?vue&type=script&lang=js"
export * from "./NChips.vue?vue&type=script&lang=js"
import style0 from "./NChips.vue?vue&type=style&index=0&id=625786bf&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports